export default __webpack_public_path__ + "static/media/img1.44635d19.png";